/* eslint-disable @typescript-eslint/no-explicit-any */

export enum EventType {
  SET_USER = 'set-user',
  MODAL_DISPLAY = 'modal-display',
  SHOW_SNACKBAR = 'show-snackbar',
}

/**
 * Dispatch JS event
 * @param eventName The name of the event
 * @param content The event content
 */
function sendEvent(eventName: EventType, content: any) {
  dispatchEvent(new CustomEvent(eventName, { detail: content }));
}

export { sendEvent };
